import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @mui/material components
import { makeStyles, withStyles } from '@mui/styles';

// material ui icons
import WysiwygIcon from '@mui/icons-material/Wysiwyg';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';

import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';

import SearchCriteria from './components/SearchCriteria';
import LogsTable from './components/Table';
import useGetFilters from './hooks/Filters';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/logStyle';

// Redux
import { selectClient } from '@features/session/sessionSlice';
import { selectNtAdministrator } from '@features/user/userSlice';

const useStyles = makeStyles(styles);

const SystemLogs = (props) => {
  const { classes } = props;
  const dispatch = useDispatch();
  const ntAdministration = useSelector(selectNtAdministrator);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [sendButton, setSendButton] = useState(false);
  const tenant = 'any';
  const client =
    ntAdministration && props?.location?.state?.tenant
      ? props.location.state.client
      : useSelector(selectClient);

  const defaultFilters = {
    startDate: null,
    endDate: null,
    applicationTypes: [],
    activeApplication: 'server',
    levelTypes: [],
    messageTypes: [],
    location: '',
    workstation: '',
    tenantId: tenant,
  };
  const [filters, setFilters] = useState(defaultFilters);

  const {
    enabled,
    locations,
    workstations,
    applications,
    levels,
    messages,
    handleClearFilters,
    handleChange,
    handleCheckboxChange,
    handleChangeCalendar,
    handleSubmitForm,
  } = useGetFilters(
    tenant.tenant_id,
    setLogs,
    perPage,
    page,
    setTotal,
    setPerPage,
    setLoading,
    filters,
    setFilters,
    defaultFilters,
    ntAdministration
  );

  return (
    <GridContainer>
      {/* Search Filters */}
      <SearchCriteria
        classes={classes}
        handleChangeCalendar={handleChangeCalendar}
        handleChange={handleChange}
        filters={filters}
        enabled={enabled}
        locations={locations}
        workstations={workstations}
        applications={applications}
        levels={levels}
        messages={messages}
        handleSubmitForm={handleSubmitForm}
        setSendButton={setSendButton}
        sendButton={sendButton}
        tenant={tenant}
        client={client}
        ntAdministration={ntAdministration}
        setFilters={setFilters}
      />
      {/* Table Content */}
      <GridItem xs={12}>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='primary'>
              <WysiwygIcon />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <LogsTable
              classes={classes}
              logs={logs}
              setPerPage={setPerPage}
              setPage={setPage}
              total={total}
              page={page}
              perPage={perPage}
              loading={loading}
              filters={filters}
              setFilters={setFilters}
              handleSubmitForm={handleSubmitForm}
              sendButton={sendButton}
              ntAdministration={ntAdministration}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(SystemLogs);
